<template>
 <div class="introduction ">
  <nav class="tip-title __fs-16 _fw-500">简介概要</nav>
  <div class="swiper-base __flex __flex-vc __flex-cc" v-if="list.length">
    <swiper class="my-swiper-base" ref="mySwiper" :options="swiperOption">
      <swiper-slide v-for="(item, index) in list" :key="index" >
        <video
          class="dpitem"
          :src="formatAliyunPath(item.src)"
          :poster="formatAliyunPath(item.src)+'?x-oss-process=video/snapshot,t_5000,f_jpg'"
          controls="controls"
          :id="'videoToplay'+index"
          webkit-playsinline playsinline x5-video-player-type="h5-page"
        ></video>
      </swiper-slide>
    </swiper>
  </div>
  <div v-show="introduce" class ="text">
    <p class="text_content" > {{introduce}} </p>
  </div>
 </div>
</template>

<script>
import { aliyun } from '@/agent'
export default {
  name: 'base-introduction',
  props: {
    list: {
      type: Array,
    },
    introduce: {
    }
  },
  data () {
    // const that = this
    return {
      videoPlay: false,
      currentIndex: 0, // 当前swiper的列
      swiperOption: {
        initialSlide: 0,
        slidesPerView: 1,
        slidesPerGroup: 1,
        paginationClickable: true,
        autoplayDisableOnInteraction: false,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: false, // 修改swiper的父元素时，自动初始化swiper
        direction: 'horizontal',
        loop: false, // 循环模式选项
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        }
      }, // swiper配置
      introduction: '',
      VideoPlayId: 0,
    }
  },
  mounted () {
    window.addEventListener('touchmove', this.scroll)
  },
  destroyed () {
    window.removeEventListener('touchmove', this.scroll)
  },
  methods: {
    // 视频是否全部展示在可视区域 若是 则播放
    scroll () {
      const videoShow = document
        .getElementsByClassName('dpitem')[0]
        .getBoundingClientRect()
      // 视频在可视区域
      if (videoShow.top >= 0 && videoShow.bottom <= document.documentElement.clientHeight) {
        if (!this.videoPlay) {
          this.videoPlay = true
          this.list.forEach((items, index) => {
            document.getElementById('videoToplay' + index).play()
          })
        }
      } else {
        if (this.videoPlay) {
          this.videoPlay = false
          this.list.forEach((items, index) => {
            document.getElementById('videoToplay' + index).pause()
          })
        }
      }
    },
    // 销毁
    beforeDestroy () {
      window.removeEventListener('scroll', this.scroll)
    },
    // 点击swiper
    handleClickSlide (currentIndex) {
      this.$emit('handle-click-slide', currentIndex)
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    }
  },
}
</script>

<style scoped lang="scss">
.introduction {
  margin: 36px 20px 0px 20px;
  border-radius: 2px;
  .tip-title {
    padding-left: 8px;
    border-left: 3px solid $main-color;
    border-radius: 2px;
    color: #282828;
    margin-bottom: 25px;
  }
  .swiper-base {
    position: relative;
    width: 335px;
    height: 188px;
    .my-swiper-base {
      width: 336px;
      height: 100%;
      .dpitem {
        width: 100%;
        height: 100%;
        border-radius: 3px;
      }
    }
  }
  .text{
    width: 100%;
    padding: 19px 13px 18px 13px;
    box-sizing: border-box;
    background: white;
    border-radius: 2px;
    .text_content{
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Regular;
      font-weight: 400;
      text-align: left;
      color: #252525;
      line-height: 18px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
</style>
